import React from 'react';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Keep the app visible in production and leave enough context for support.
    // eslint-disable-next-line no-console
    console.error('App render error', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="app-shell">
          <div className="client-detail-section">
            <div className="eyebrow">Erro na tela</div>
            <h2>Não foi possível carregar esta ferramenta</h2>
            <p className="text-muted">
              Atualize a página. Se o problema continuar, envie o horário e a ferramenta que estava tentando abrir.
            </p>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              Atualizar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
